"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.forceLowerStatusForExpiredSystem = forceLowerStatusForExpiredSystem;
exports.updateSystemStatus = updateSystemStatus;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const GraphQLRequest = __importStar(require("@genesys/graphql-request"));
const system_status_1 = require("@genesys/shared/lib/enums/system-status");
const case_type_1 = require("@genesys/shared/lib/enums/case-type");
// import { config } from "../../../client-config";
const updateSystemMutation = (0, graphql_tag_1.default) `
  mutation UpdateSystemStatus($input: UpdateSystemInputType!) {
    updateSystem(input: $input) {
      __typename
      ... on UpdateSystemSuccessResultType {
        status
      }

      ... on UpdateSystemRejectResultType {
        rejectReason
      }
    }
  }
`;
const calculateEnergiBinCaseMutation = (0, graphql_tag_1.default) `
  mutation CalculateEnergyBinCase($input: CalculateEnergyBinCaseInputType!) {
    calculateEnergyBinCase(input: $input)
  }
`;
const checkSystemStatusQuery = (0, graphql_tag_1.default) `
  query CheckSystemStatusQuery($systemId: ID!) {
    user {
      system(id: $systemId) {
        id
        status
        operatingCases {
          id
          caseType
        }
      }
    }
  }
`;
async function forceLowerStatusForExpiredSystem(setLoadingIndicator, includeServerLog, systemId, graphqlEndpoint, authorization) {
    setLoadingIndicator({
        type: "PleaseWaitIndicator"
    });
    const result = await tryUpdateSystemStatus(setLoadingIndicator, includeServerLog, systemId, system_status_1.SystemStatus.ConfigureSystemSuccess, true, graphqlEndpoint, authorization);
    return result;
}
async function updateSystemStatus(setLoadingIndicator, includeServerLog, systemId, targetStatus, graphqlEndpoint, authorization) {
    // Because we haven't done a re render yet we need to query the server for status. You could argue that this
    // should be done outside this function.
    // This should be solved with a queue on the server. This logic dont belong on the client and is only here because of
    // a progress bar of the energy calculcation and no time to convert to server side queue at this stage of the javascript conversion.
    setLoadingIndicator({
        type: "PleaseWaitIndicator"
    });
    const { user: { system: { operatingCases, status } } } = await GraphQLRequest.request(checkSystemStatusQuery, {
        systemId: systemId
    }, includeServerLog, graphqlEndpoint, authorization);
    const binCases = operatingCases
        .filter(oc => oc.caseType === case_type_1.CaseType.Bin)
        .map(oc => oc.id);
    if (targetStatus < system_status_1.SystemStatus.EnergyCalculationSuccess ||
        binCases.length === 0) {
        return tryUpdateSystemStatus(setLoadingIndicator, includeServerLog, systemId, targetStatus, false, graphqlEndpoint, authorization);
    }
    let currentStatus = status;
    // Energy is needed, need to do it in steps, first to price, then to energy, then to final target
    // Step 1, price if needed
    if (currentStatus < system_status_1.SystemStatus.PriceCalculationSuccess) {
        const updateToPricingResult = await tryUpdateSystemStatus(setLoadingIndicator, includeServerLog, systemId, system_status_1.SystemStatus.PriceCalculationSuccess, false, graphqlEndpoint, authorization);
        if (updateToPricingResult.type === "UpdateSystemResultReject") {
            return updateToPricingResult;
        }
        currentStatus = updateToPricingResult.status;
    }
    // Step 2, energy, don't recalculate energy if already done
    if (targetStatus >= system_status_1.SystemStatus.EnergyCalculationSuccess &&
        currentStatus < system_status_1.SystemStatus.EnergyCalculationSuccess) {
        await calculateBinCases(setLoadingIndicator, includeServerLog, systemId, binCases, graphqlEndpoint, authorization);
    }
    // Step 3, final target
    if (currentStatus < targetStatus) {
        const updateToTargetResult = await tryUpdateSystemStatus(setLoadingIndicator, includeServerLog, systemId, targetStatus, false, graphqlEndpoint, authorization);
        if (updateToTargetResult.type === "UpdateSystemResultReject") {
            return updateToTargetResult;
        }
    }
    return {
        type: "UpdateSystemResultSuccess",
        status: targetStatus
    };
}
async function tryUpdateSystemStatus(setLoadingIndicator, includeServerLog, systemId, targetStatus, forceUpdate, graphqlEndpoint, authorization) {
    setLoadingIndicator({
        type: "CalculatingSystemIndicator"
    });
    try {
        const { updateSystem } = await GraphQLRequest.request(updateSystemMutation, {
            input: {
                forceUpdate,
                systemId,
                targetStatus
            }
        }, includeServerLog, graphqlEndpoint, authorization);
        setLoadingIndicator({
            type: "NothingIndicator"
        });
        switch (updateSystem.__typename) {
            case "UpdateSystemSuccessResultType": {
                return {
                    type: "UpdateSystemResultSuccess",
                    status: updateSystem.status
                };
            }
            case "UpdateSystemRejectResultType": {
                console.error(updateSystem.rejectReason);
                return {
                    type: "UpdateSystemResultReject",
                    error: updateSystem.rejectReason
                };
            }
            case undefined: {
                return {
                    type: "UpdateSystemResultReject",
                    error: "typename is undefined"
                };
            }
            default: {
                (0, ts_exhaustive_check_1.exhaustiveCheck)(updateSystem);
                return {
                    type: "UpdateSystemResultReject",
                    error: "shouldnt happen"
                };
            }
        }
    }
    catch (e) {
        return {
            type: "UpdateSystemResultReject",
            error: e
        };
    }
}
async function calculateBinCases(setLoadingIndicator, includeServerLog, systemId, binCases, graphqlEndpoint, authorization) {
    for (let i = 0; i < binCases.length; i++) {
        setLoadingIndicator({
            type: "CalculatingEnergyIndicator",
            currentCase: i + 1,
            totalCases: binCases.length
        });
        await GraphQLRequest.request(calculateEnergiBinCaseMutation, {
            input: {
                systemId,
                binCaseId: binCases[i]
            }
        }, includeServerLog, graphqlEndpoint, authorization);
    }
    setLoadingIndicator({
        type: "NothingIndicator"
    });
}
//# sourceMappingURL=index.js.map